var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPatternBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 86,
    viewBox: "0 0 126 86",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6719 -72.3555L60.6927 -60.3347L-51.8298 52.1878L-63.8506 40.167L48.6719 -72.3555ZM72.7109 -48.3193L84.7318 -36.2985L-27.7873 76.2206L-39.8081 64.1998L72.7109 -48.3193ZM108.271 -11.7546L96.25 -23.7754L-15.7749 88.2496L-3.75413 100.27L108.271 -11.7546ZM119.789 0.765625L131.81 12.7864L20.2835 124.313L8.26265 112.292L119.789 0.765625ZM153.857 38.8314L141.836 26.8105L32.312 136.335L44.3328 148.355L153.857 38.8314Z",
    fill: "url(#paint0_linear_6231_32071)",
    fillOpacity: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6231_32071",
    x1: -63.8516,
    y1: 37.9999,
    x2: 118.836,
    y2: 117.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2F374",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81EDB2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternBg);
export default __webpack_public_path__ + "static/media/pattern-bg.4c2fe7a9993846d896e7df3e5b39ee71.svg";
export { ForwardRef as ReactComponent };